export function BarChart({ bars, exact = false, labelClass, height = 132 }: { bars: { label: string; h: number; color: string; bold?: boolean }[]; exact?: boolean; labelClass?: string; height?: number }) {
  const max = Math.max(1, ...bars.map(b => b.h));
  return (
    <div className="flex items-end gap-2" style={{ height }}>
      {bars.map((b, i) => (
        <div key={i} className="flex-1 flex flex-col items-center gap-[7px]">
          <div className="w-full rounded-t-[5px] rounded-b-[2px]"
            style={{ height: exact ? b.h : (b.h / max) * 106, background: b.color }} />
          <div className={labelClass ?? `font-grotesk text-[10.5px] ${b.bold ? "font-bold text-ink" : "text-ink3"}`}>{b.label}</div>
        </div>))}
    </div>);
}
